// Class: starling.text.ITextCompositor

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var ITextCompositor = function() {}

// Meta

ITextCompositor.__name__ = ["starling","text","ITextCompositor"];
ITextCompositor.prototype = {
	
};
ITextCompositor.prototype.__class__ = ITextCompositor.prototype.constructor = $hxClasses["starling.text.ITextCompositor"] = ITextCompositor;

// Init



// Statics




// Export

exports.default = ITextCompositor;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/text/ITextCompositor.js
// module id = 80
// module chunks = 0